import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import MatchDetail from '@/pages/MatchDetail';
import Profile from '@/pages/Profile';
import AdminPanel from '@/pages/AdminPanel';
import PaymentPage from '@/pages/PaymentPage';
import AggregatePaymentPage from '@/pages/AggregatePaymentPage';
import AdminNotifications from '@/pages/AdminNotifications';
import SundayTeamAllocation from '@/pages/SundayTeamAllocation';
import SaturdayTeamSelection from '@/pages/SaturdayTeamSelection';
import SelectionArena from '@/pages/SelectionArena';
import AwardsPage from '@/pages/AwardsPage';
import AuthCallback from '@/pages/AuthCallback';
import ProtectedRoute from '@/components/ProtectedRoute';
import '@/App.css';

// Register service worker early
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registered:', registration.scope);
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }
};

function AppRouter() {
  const location = useLocation();
  
  // Register service worker on mount
  useEffect(() => {
    registerServiceWorker();
  }, []);
  
  // Check for session_id in URL fragment synchronously
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/match/:matchId" element={<ProtectedRoute><MatchDetail /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/payments" element={<ProtectedRoute><AggregatePaymentPage /></ProtectedRoute>} />
      <Route path="/payment/:paymentId" element={<ProtectedRoute><PaymentPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
      <Route path="/admin/notifications" element={<ProtectedRoute><AdminNotifications /></ProtectedRoute>} />
      <Route path="/admin/allocate-teams/:matchId" element={<ProtectedRoute><SundayTeamAllocation /></ProtectedRoute>} />
      <Route path="/admin/select-saturday/:matchId" element={<ProtectedRoute><SaturdayTeamSelection /></ProtectedRoute>} />
      <Route path="/arena/:matchId" element={<ProtectedRoute><SelectionArena /></ProtectedRoute>} />
      <Route path="/awards" element={<ProtectedRoute><AwardsPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;